<template>
  <table class="table">
    <tr class="d-flex">
      <th scope="col" class="col-3">Date</th>
      <th scope="col" class="col">Feedback</th>
      <th scope="col" class="col-3">Email</th>
    </tr>
    <tr class="d-flex" v-for="item in feedbackItems" :key="item.id">
      <th class="col-3">{{item.dateFormatted}}</th>
      <td class="col">{{item.feedback}}</td>
      <td class="col-3">{{item.user}}</td>
    </tr>
  </table>
</template>
<script>
import { getFeedback } from '@/utils/services'
import format from 'date-fns/format'

export default {
  computed: {
    user() {
      return this.$store.state.user
    },
    initialized() {
      return this.$store.state.initialized
    }
  },
  data() {
    return {
      feedbackItems: []
    }
  },
  mounted() {
    this.getFeedback()
  },
  methods: {
    async getFeedback() {
      const items = await getFeedback()
      this.feedbackItems = items.map(item => {
        return {
          ...item,
          dateFormatted: format(item.date, 'HH:mm @ D/M/YY')
        }
      }).sort((a, b) => b.date - a.date)
      // try {
      //   const querySnapshot = await db.collection('feedback').get()
      //   this.feedbackItems = querySnapshot.docs.map(doc => {
      //     const item = doc.data()
      //     const date = item.date || 0
      //     return {
      //       ...item,
      //       date,
      //       id: doc.id,
      //       dateFormatted: format(date, 'HH:mm @ D/M/YY')
      //     }
      //   }).sort((a, b) => b.date - a.date)
      // } catch (e) {
      //   console.log(e)
      // }
    }
  },
  watch: {
    initialized() {
      this.getFeedback()
    }
  }
}
</script>
